import React from 'react';
import classNames from 'classnames';
import style from './styles.scss';

const StatusContainer = ({ typoNo, sets, noOfUnassigned }) => {
  return (
    <div className={style.statusContainer}>
      <p className={style.viewHeader}>Overview</p>
      <div className={style.typologyDetails}>
        <p className={classNames(style.typoDetailsHead, style.typoOne)}>
          This run instance has
          <span className={style.typoNo}> {typoNo} Typologies </span>
          and <span className={style.typoNo}>{sets} Sets.</span>
          <p className={style.typoDetailsHead}>
            {' '}
            Note:
            <span className={style.typoStatus}>
              {' '}
              {noOfUnassigned} Typologies are currently unassigned
            </span>
          </p>
        </p>
      </div>
    </div>
  );
};

export default StatusContainer;
